// Functions
export { productCodeToUnifiedProductID, unifiedProductIDToProductCode } from './common/productCode';
export { fetchUnifiedProduct } from './product/fetchUnifiedProduct';
export { fetchUnifiedProductsByCodes } from './productsByCodes/fetchUnifiedProductsByCodes';

// Types
export type { FetchUnifiedProductArgs } from './product/fetchUnifiedProduct';
export type {
  UnifiedProduct,
  UnifiedProductAttributePrimitive,
  UnifiedProductAttributeValue,
  UnifiedProductCustomAttribute,
  UnifiedProductDelivery,
  UnifiedProductDeliveryByEvent,
  UnifiedProductDetailImage,
  UnifiedProductIngredientsLink,
  UnifiedProductLink,
  UnifiedProductNavigationBlock,
  UnifiedProductNavigationOption,
  UnifiedProductPartnerInfo,
  UnifiedProductRating,
  UnifiedProductSpecialFeatures,
  UnifiedProductTypedAttributeValue,
} from './product/types/UnifiedProduct';
export type {
  FetchUnifiedProductsByCodesArgs,
  UnifiedProductsByCodesResult,
} from './productsByCodes/fetchUnifiedProductsByCodes';
export type {
  UnifiedProductImage,
  UnifiedProductPrice,
  UnifiedProductPriceInfo,
  UnifiedProductSummary,
  UnifiedProductSummaryAttributes,
  UnifiedProductSummaryResponse,
} from './productsByCodes/types/UnifiedProductSummary';

// Fixtures and builders
export {
  buildCustomAttribute,
  buildUnifiedProduct,
  unifiedProduct,
} from './product/fixtures/unifiedProduct';
export { buildUnifiedProductSummary } from './productsByCodes/fixtures/unifiedProductSummary';
